export enum LocationStatuses {
  ACTIVE = 'Active',
  INACTIVE = 'Inactive'
}
